/* ==========================================================================
   Collection (native)
   - Selector de variantes + add to cart en la card
   - Filtrado y ordenamiento vía Section Rendering API (estándar Shopify)
   ========================================================================== */

(function () {
  'use strict';

  if (window.__cnCollectionInit) return;
  window.__cnCollectionInit = true;

  var SECTION = '[data-cn-section]';

  function section(el) {
    return el ? el.closest(SECTION) : null;
  }

  /* ---------------------------------------------------------------- Cards */

  function variantsOf(card) {
    if (card.__cnVariants) return card.__cnVariants;

    var node = card.querySelector('[data-cn-variants]');
    if (!node) return [];

    try {
      card.__cnVariants = JSON.parse(node.textContent);
    } catch (e) {
      card.__cnVariants = [];
    }
    return card.__cnVariants;
  }

  function closeAllSelects(except) {
    document.querySelectorAll('[data-cn-select][data-open]').forEach(function (select) {
      if (select === except) return;
      select.removeAttribute('data-open');
      var list = select.querySelector('[data-cn-select-list]');
      var trigger = select.querySelector('[data-cn-select-trigger]');
      var card = select.closest('[data-cn-card]');
      if (list) list.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (card) card.removeAttribute('data-select-open');
    });
  }

  function toggleSelect(select) {
    var isOpen = select.hasAttribute('data-open');
    closeAllSelects(select);

    var list = select.querySelector('[data-cn-select-list]');
    var trigger = select.querySelector('[data-cn-select-trigger]');
    var card = select.closest('[data-cn-card]');

    if (isOpen) {
      select.removeAttribute('data-open');
      if (list) list.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (card) card.removeAttribute('data-select-open');
    } else {
      select.setAttribute('data-open', '');
      if (list) list.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      // eleva la card para que la lista no quede debajo de las siguientes
      if (card) card.setAttribute('data-select-open', '');
    }
  }

  /**
   * Cambia la imagen de la card a la de la variante. Si la variante no tiene
   * imagen propia, restaura la featured image del producto.
   */
  function updateImage(card, variant) {
    var img = card.querySelector('[data-cn-image]');
    if (!img) return;

    // La primera vez guardamos la imagen original para poder volver a ella
    if (!img.dataset.defaultSrc) {
      img.dataset.defaultSrc = img.getAttribute('src') || '';
      img.dataset.defaultSrcset = img.getAttribute('srcset') || '';
      img.dataset.defaultAlt = img.getAttribute('alt') || '';
    }

    var next = variant.image || {
      src: img.dataset.defaultSrc,
      srcset: img.dataset.defaultSrcset,
      alt: img.dataset.defaultAlt
    };

    if (img.getAttribute('src') === next.src) return;

    img.setAttribute('src', next.src);

    if (next.srcset) {
      img.setAttribute('srcset', next.srcset);
    } else {
      img.removeAttribute('srcset');
    }

    if (next.alt) img.setAttribute('alt', next.alt);
  }

  function selectVariant(card, variantId) {
    var variant = variantsOf(card).filter(function (v) {
      return String(v.id) === String(variantId);
    })[0];
    if (!variant) return;

    updateImage(card, variant);

    var label = card.querySelector('[data-cn-select-label]');
    if (label) label.textContent = variant.title;

    card.querySelectorAll('[data-cn-select-option]').forEach(function (option) {
      var selected = String(option.dataset.variantId) === String(variantId);
      option.classList.toggle('cn-select__option--selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    var price = card.querySelector('[data-cn-price]');
    if (price) {
      var html = '<span class="cn-card__price-amount">' + variant.price + '</span>';
      if (variant.compare_at_price) {
        html += '<s class="cn-card__price-compare">' + variant.compare_at_price + '</s>';
      }
      price.innerHTML = html;
    }

    var atc = card.querySelector('[data-cn-atc]');
    if (atc) {
      atc.dataset.variantId = variant.id;
      atc.disabled = !variant.available;
      atc.textContent = variant.available
        ? atc.dataset.labelAdd || atc.textContent
        : atc.dataset.labelSoldOut || atc.textContent;
    }
  }

  /* ------------------------------------------------------------ Add to cart */

  function addToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.hasAttribute('data-loading')) return;

    var original = button.textContent;
    button.setAttribute('data-loading', '');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
        return response.json();
      })
      .then(function () {
        var EM = window.ExpressionMed;

        if (EM && typeof EM.refreshAfterNostoAdd === 'function') {
          EM.refreshAfterNostoAdd();
        } else if (window.jQuery) {
          window.jQuery('.cart-button').click();
          window.jQuery(document).trigger('cart:updated');
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        console.error('[collection-native]', error);
      })
      .finally(function () {
        button.removeAttribute('data-loading');
        button.textContent = original;
      });
  }

  /* --------------------------------------------------- Filtrado / ordenado */

  var debounceTimer;

  function buildUrl(form) {
    var params = new URLSearchParams();

    new FormData(form).forEach(function (value, key) {
      if (value !== '' && value !== null) params.append(key, value);
    });

    var query = params.toString();
    return form.getAttribute('action') + (query ? '?' + query : '');
  }

  function render(root, url, pushState) {
    var form = root.querySelector('[data-cn-form]');
    var results = root.querySelector('[data-cn-results]');
    if (!form) return;

    if (results) results.setAttribute('data-loading', '');

    var sectionId = root.dataset.sectionId;
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-cn-form]');
        if (!next) throw new Error('No se encontró [data-cn-form] en la respuesta');

        var sidebar = root.querySelector('[data-cn-sidebar]');
        var wasOpen = sidebar && sidebar.hasAttribute('data-open');

        form.innerHTML = next.innerHTML;

        if (wasOpen) {
          var newSidebar = root.querySelector('[data-cn-sidebar]');
          if (newSidebar) newSidebar.setAttribute('data-open', '');
        }

        if (pushState !== false) {
          window.history.pushState({ cn: true }, '', url);
        }
      })
      .catch(function (error) {
        console.error('[collection-native]', error);
        window.location.href = url;
      })
      .finally(function () {
        var current = root.querySelector('[data-cn-results]');
        if (current) current.removeAttribute('data-loading');
      });
  }

  /* -------------------------------------------------------------- Listeners */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cn-select-trigger]');
    if (trigger) {
      event.preventDefault();
      toggleSelect(trigger.closest('[data-cn-select]'));
      return;
    }

    var option = event.target.closest('[data-cn-select-option]');
    if (option) {
      event.preventDefault();
      var card = option.closest('[data-cn-card]');
      selectVariant(card, option.dataset.variantId);
      closeAllSelects();
      return;
    }

    var atc = event.target.closest('[data-cn-atc]');
    if (atc) {
      event.preventDefault();
      addToCart(atc);
      return;
    }

    var openDrawer = event.target.closest('[data-cn-drawer-open]');
    if (openDrawer) {
      var root = section(openDrawer);
      var sidebar = root && root.querySelector('[data-cn-sidebar]');
      var overlay = root && root.querySelector('.cn__overlay');
      if (sidebar) sidebar.setAttribute('data-open', '');
      if (overlay) overlay.hidden = false;
      return;
    }

    var closeDrawer = event.target.closest('[data-cn-drawer-close]');
    if (closeDrawer) {
      var closeRoot = section(closeDrawer);
      var closeSidebar = closeRoot && closeRoot.querySelector('[data-cn-sidebar]');
      var closeOverlay = closeRoot && closeRoot.querySelector('.cn__overlay');
      if (closeSidebar) closeSidebar.removeAttribute('data-open');
      if (closeOverlay) closeOverlay.hidden = true;
      return;
    }

    // Filtros activos, "clear all" y paginación → navegación sin recarga
    var link = event.target.closest('[data-cn-link], .cn__pagination a');
    if (link && section(link)) {
      event.preventDefault();
      render(section(link), link.getAttribute('href'));
      return;
    }

    closeAllSelects();
  });

  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-cn-form]');
    if (!form) return;

    var root = section(form);
    if (!root) return;

    // Los inputs de rango de precio se escriben carácter a carácter
    var isRange = event.target.type === 'number';
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(
      function () {
        render(root, buildUrl(form));
      },
      isRange ? 500 : 0
    );
  });

  document.addEventListener('input', function (event) {
    if (event.target.type !== 'number') return;

    var form = event.target.closest('[data-cn-form]');
    if (!form) return;

    var root = section(form);
    if (!root) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      render(root, buildUrl(form));
    }, 700);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cn-form]');
    if (!form) return;

    event.preventDefault();
    render(section(form), buildUrl(form));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeAllSelects();

    document.querySelectorAll('[data-cn-sidebar][data-open]').forEach(function (sidebar) {
      sidebar.removeAttribute('data-open');
      var overlay = section(sidebar) && section(sidebar).querySelector('.cn__overlay');
      if (overlay) overlay.hidden = true;
    });
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll(SECTION).forEach(function (root) {
      render(root, window.location.href, false);
    });
  });

  // Marca que hay JS para ocultar el botón "Apply" (fallback sin JS)
  function markJs() {
    document.querySelectorAll(SECTION).forEach(function (root) {
      root.classList.add('cn--js');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markJs);
  } else {
    markJs();
  }
})();
